import { render } from "./Loading.vue?vue&type=template&id=43e4a6f1"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=43e4a6f1&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__